
import React, { useState, useEffect } from "react";

import { GET_SPOT_BIDDING_REQ_BY_ID, GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_ID } from '../../../common/URLs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { PROD, PIT_ROLES } from '../../../common/constants';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { Fab, Typography, Container, Card, CardContent, Stack, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { DataGrid } from "@mui/x-data-grid";
import apiClient from "../../../axios";


export function BiddingDetails() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [scheduleDetails, setScheduleDetails] = useState();
    const state = useLocation().state;
    const schedule = useLocation().state?.selectedRow;

    useEffect(() => {
        getSchedulePlanByScheduleNo();
    }, [schedule]);

    const getSchedulePlanByScheduleNo = () => {
        loaderService.showLoader();
        apiClient.post(GET_SPOT_BIDDING_REQ_BY_ID,
            {
                // "stakeholderType": "Transporter",
                "id": schedule?.id,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setScheduleDetails(response.data?.spotBiddingAllotmentRequestDetails);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT67</p>}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab
                        size="small"
                        aria-label="back"
                        title="Back"
                        onClick={() => navigate(-1)} 
                    >
                        <KeyboardArrowLeftRounded />
                    </Fab> Bidding Details
                </Typography>
                <Card>
                    <CardContent>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} >
                            <Stack direction="column">
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Bid Number: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.bidNumber}
                                    </Typography>
                                </Stack>
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Base Rate(per ton per KM)(in INR): </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {(scheduleDetails?.baseBidPrice)?.toFixed(2)}
                                    </Typography>
                                </Stack>
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Distance(in KM): </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.distanceTravelled}
                                    </Typography>
                                </Stack>

                                {/* <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Approved By: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>

                                    </Typography>
                                </Stack> */}
                            </Stack>
                            <Stack direction="column">
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Bidding Start Date: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.biddingStartDate ? moment(scheduleDetails?.biddingStartDate).format("DD/MM/YYYY") : '-'}
                                    </Typography>
                                </Stack>
                                 <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Bidding Start Time: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.biddingStartTime ? moment(scheduleDetails?.biddingStartTime, 'HH:mm:ss').format('hh:mm A') : '-'}
                                    </Typography>
                                </Stack>

                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>{t('pit.quantity') + '(MT)'}: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.allotmentQuantity}
                                    </Typography>
                                </Stack>


                            </Stack>
                            <Stack direction="column">
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Bidding End Date: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.biddingEndDate ? moment(scheduleDetails?.biddingEndDate).format("DD/MM/YYYY") : '-'}
                                    </Typography>
                                </Stack>
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Bidding End Time: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.biddingEndTime ? moment(scheduleDetails?.biddingEndTime, 'HH:mm:ss').format('hh:mm A') : '-'}
                                    </Typography>
                                </Stack>
                                <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Material Type: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.materialType}
                                    </Typography>
                                </Stack>

                                {/* <Stack direction="row">
                                    <Typography variant="subtitle2" gutterBottom>Current Transporter: </Typography>
                                    <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                        {scheduleDetails?.stakeholderUrn}
                                    </Typography>
                                </Stack> */}
                            </Stack>
                            {/* <Stack direction="column">
                            
                            </Stack> */}
                        </Stack>
                        <Grid container spacing={1} direction='row'>
                            <Grid item xs={12} lg={6}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
                                    <Stack direction="column">
                                        <Typography variant="subtitle1" gutterBottom>Origin Details</Typography>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Name : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Type : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyType}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyUrn}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Contact Person : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyContactName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Phone Number : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyContactNo}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Location Name : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyLocationName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom> Location Address : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyLocationAddress}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>GSTIN : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.firstPartyGstin}
                                            </Typography>
                                        </Stack>

                                    </Stack>

                                </Stack>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
                                    <Stack direction="column">
                                        <Typography variant="subtitle1" gutterBottom>Destination Details</Typography>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Name : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Type : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyType}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyUrn}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Contact Person : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyContactName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Phone Number : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyContactNo}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>Location Name : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyLocationName}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom> Location Address : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyLocationAddress}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row">
                                            <Typography variant="subtitle2" gutterBottom>GSTIN : </Typography>
                                            <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                                                {scheduleDetails?.secondPartyGstin}
                                            </Typography>
                                        </Stack>

                                    </Stack>
                                </Stack>

                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>

            </Container>
        </>
    )
}